import { FromScreen } from 'src/app/models/from-screen';
import { Checkout } from './models/checkout';

export class GetCheckouts {
  static readonly type = '[Checkouts] - Get checkouts';
}

export class PostCheckout {
  static readonly type = '[Checkouts] - Post checkout';

  constructor(
    public recordId: string,
    public from: FromScreen,
    public issueDate?: string,
    public rhId?: string
  ) {}
}

export class PostRenewCheckout {
  static readonly type = '[Checkouts] - Post renew checkout';

  constructor(public checkoutUpdated: Checkout) {}
}

export class PostReturnCheckout {
  static readonly type = '[Checkouts] - Post return checkout';

  constructor(public checkoutId: string) {}
}

export class SetCheckout {
  static readonly type = '[Checkouts] - Set checkout';

  constructor(public checkoutUpdated: Checkout) {}
}
